import script from "./SubAdminRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./SubAdminRegister.vue?vue&type=script&setup=true&lang=js"

import "./SubAdminRegister.vue?vue&type=style&index=0&id=79d4b884&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d4b884"]])

export default __exports__